<div class="map-container">
  <div class="map-frame" *ngIf="!showMessage else noFound">
    <div id="map"></div>
  </div>
  <ng-template #noFound>
    <label>Siamo spiacenti, non è stato possibile geolocalizzare l'indirizzo</label>
  </ng-template>
</div>
